import { createActions, createReducer } from "reduxsauce";
import { urls } from "../../api/urls";
import { apiConfig } from "../../api/config";
import { ILabel } from "../dataMap/label";
import { Creators as ArticleCreators } from "./article";

/**Actions and types definitions **/
export const { Types, Creators } = createActions({
  getLabelsRequest: null,
  getLabelsSuccess: ["labels"],
  setFailure: ["error"],
  setLabel: ["label"],
  editLabel: ["label"],
  deleteLabel: ["labelId"],
});

interface ILabelState {
  labels: ILabel[];
  isLoading: boolean;
  error: string;
}

const INITIAL_STATE: ILabelState = {
  labels: [] as ILabel[],
  isLoading: false,
  error: "",
};

export const request = (state = INITIAL_STATE): ILabelState => {
  return {
    ...state,
    isLoading: true,
    error: "",
  };
};

export const success = (
  state = INITIAL_STATE,
  action: { labels: ILabel[] }
): ILabelState => {
  return {
    ...state,
    labels: action.labels,
    error: "",
  };
};

export const failure = (
  state = INITIAL_STATE,
  action: { error: string }
): ILabelState => {
  return {
    ...state,
    error: action.error,
    isLoading: false,
  };
};

export const newLabel = (
  state = INITIAL_STATE,
  action: { label: ILabel }
): ILabelState => {
  const label = state.labels.find((label) => label.id === action.label.id);
  let labels = state.labels;
  if (!label) labels = state.labels.concat(action.label);
  return {
    ...state,
    labels: labels,
    error: "",
  };
};

export const editLabel = (
  state = INITIAL_STATE,
  action: { label: ILabel }
): ILabelState => {
  const labelIndex = state.labels.findIndex(
    (label) => label.id === action.label.id
  );
  let labels = [...state.labels];
  if (labelIndex !== -1) labels[labelIndex] = { ...action.label };
  return {
    ...state,
    labels: labels,
    error: "",
  };
};

export const deleteLabel = (
  state = INITIAL_STATE,
  action: { labelId: number }
): ILabelState => {
  return {
    ...state,
    labels: state.labels.filter((label) => label.id !== action.labelId),
    error: "",
  };
};

export const HANDLERS = {
  [Types.GET_LABELS_REQUEST]: request,
  [Types.GET_LABELS_SUCCESS]: success,
  [Types.SET_FAILURE]: failure,
  [Types.SET_LABEL]: newLabel,
  [Types.EDIT_LABEL]: editLabel,
  [Types.DELETE_LABEL]: deleteLabel,
};

export default createReducer(INITIAL_STATE, HANDLERS);

export const Actions = {
  ...Creators,

  fetchLabels: (dispatch, articleId: number) => {
    // dispatch(Creators.getLabelsSuccess(labelsMock));
    dispatch(Creators.getLabelsRequest());
    apiConfig
      .get(`${urls.ARTICLES}${articleId}/labels/`)
      .then((resp) => {
        dispatch(Creators.getLabelsSuccess(resp));
      })
      .catch((error) => {
        dispatch(Creators.setFailure(error));
      });
  },

  newLabel: (dispatch, articleId: number, label: ILabel) => {
    dispatch(Creators.getLabelsRequest());
    apiConfig
      .post(`${urls.ARTICLES}${articleId}/labels/`, label)
      .then((resp) => {
        dispatch(Creators.setLabel(resp.data));
        dispatch(ArticleCreators.setLabel(articleId, resp.data));
      })
      .catch((error) => {
        dispatch(Creators.setFailure(error));
      });
  },

  editLabel: (dispatch, label: ILabel) => {
    dispatch(Creators.getLabelsRequest());
    apiConfig
      .patch(`${urls.LABEL}${label.id}/`, {
        name: label.name,
        color: label.color,
      })
      .then((resp) => {
        dispatch(Creators.editLabel(resp.data));
        dispatch(ArticleCreators.editLabel(resp.data));
      })
      .catch((error) => {
        dispatch(Creators.setFailure(error));
      });
  },

  deleteLabel: (dispatch, labelId: number) => {
    dispatch(Creators.getLabelsRequest());
    apiConfig
      .delete(`${urls.LABEL}${labelId}/`)
      .then(() => {
        dispatch(Creators.deleteLabel(labelId));
        dispatch(ArticleCreators.deleteLabel(labelId));
      })
      .catch((error) => {
        dispatch(Creators.setFailure(error));
      });
  },
};
